import { render, staticRenderFns } from "./DSModal.vue?vue&type=template&id=b8e78c44&scoped=true&"
import script from "./DSModal.vue?vue&type=script&lang=ts&"
export * from "./DSModal.vue?vue&type=script&lang=ts&"
import style0 from "./DSModal.vue?vue&type=style&index=0&id=b8e78c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e78c44",
  null
  
)

export default component.exports